/* eslint-disable */
(function($, Drupal, once) {
  'use strict';
  window.eventQueue = {
    resizeBounce: null,
    readyEvents: [],
    resizeEvents: [],
    scrollEvents: [],
    // function to be run, and boolean to say if it should be run a second time on the same page (ajax, etc)
    addReady: function(fn, label = '', onRefresh = false) {
      this.readyEvents.push({
        'fn': fn,
        'label': label,
        'onRefresh': onRefresh
      });
    },
    ready: function() {
      // each item will flag if it should run again on secondary ready, ajax refresh, etc.
      this.readyEvents.forEach(e => {
        if (!window.documentReady || e.onRefresh) {
          // console.log('ready', e.label);
          e.fn();
        }
      });
      window.documentReady = true;
    },
    addResize: function(fn, onH = true, onW = true) {
      this.resizeEvents.push({
        'fn': fn,
        'onW': onW,
        'onH': onH
      });
    },

    resize: function() {
      if (!window.resizeOriginal) {
        window.resizeOriginal = {
          w: window.innerWidth,
          h: window.innerHeight
        };
      }
      clearTimeout(this.resizeBounce);
      const self = this;
      this.resizeBounce = setTimeout(function() {
        const changeW = window.resizeOriginal.w !== window.innerWidth;
        const changeH = window.resizeOriginal.h !== window.innerHeight;
        window.resizeOriginal = null;
        self.resizeEvents.forEach(e => {
          if ((changeW && e.onW) || (changeH && e.onH)) {
            e.fn();
          }
        });
      }, 50);
    },
    addScroll: function(fn) {
      this.scrollEvents.push(fn);
    },
    scroll: function() {
      clearTimeout(this.scrollBounce);
      const self = this;
      this.scrollBounce = setTimeout(function() {
        self.scrollEvents.forEach(fn => {
          fn();
        });
      }, 50);
    }
  };
  if (location.href.match(/node\/[0-9]+\/layout/)) {
    window.layoutBuilder = true;
  }


  jQuery(document).ready(function() {
    window.eventQueue.ready();
  });

  if (!window.layoutBuilder) {

    jQuery(once('ajaxComplete', document)).ajaxComplete(function(event, xhr, ajaxSettings) {
      window.eventQueue.ready();
    });

    jQuery(window).resize(function() {
      window.eventQueue.resize();
    });

    jQuery(window).scroll(function() {
      window.eventQueue.scroll();
    });
  }
})(jQuery, Drupal, once);
